import { axios } from "common/helpers"

export function get() {
    return axios.get("/api/catalogs")
}

export function getOne(id) {
    return axios.get(`/api/catalogs/${id}`)
}

export function update(catalog) {
    const { company, settings, setting, ...rest } = catalog
    const iconSets = setting?.meta?.iconSets?.map(iconSet => iconSet.id)
    return axios.patch(`/api/catalogs/${catalog.id}`, {
        ...rest,
        company: company?.id,
        setting: {
            ...setting,
            catalog: catalog.id,
            meta: {
                ...setting?.meta,
                iconSets
            }
        }
    })
}

export function create(catalog) {
    const { company, settings, setting, ...rest } = catalog
    const iconSets = setting?.meta?.iconSets?.map(iconSet => iconSet.id)
    return axios.post("/api/catalogs", {
        ...rest,
        company: company?.id,
        setting: {
            ...setting,
            meta: {
                ...setting?.meta,
                iconSets
            }
        }
    })
}

export async function remove(id) {
    await axios.delete(`/api/catalogs/${id}`)
}
